import { VERSION } from "../../services/constants";
import { localize } from "../../services/localize";

const VersionDisplay = () => {
  return (
    <div
      className={
        "flex pl-1 font-black justify-start items-start text-color-dark-text-secondary uppercase"
      }
    >
      {localize("COPY_VERSION")} {VERSION}
    </div>
  );
};

export default VersionDisplay;
